// extracted by mini-css-extract-plugin
export default {"Subtitle":"Subtitle_Subtitle__91CPz","Subtitle__centered":"Subtitle_Subtitle__centered__e7uiS","spin":"Subtitle_spin__pgY7+"};